import React from "react";
import { Scrollbar } from "react-scrollbars-custom";
import "./Table.css";

export const Table = ({ height = "100px", columns = [], rows = [] }) => {
    return (
        <Scrollbar style={{ height }} className="tableScroll">
            <table className="clickRequestsTable">
                <thead>
                <tr>
                    {columns.map((col) => (
                        <th
                            key={col.key}
                            className="clickRequestsHead"
                            style={col.headerStyle}
                        >
                            {col.label}
                        </th>
                    ))}
                </tr>
                </thead>
                <tbody>
                {rows.map((row, i) => (
                    <tr
                        key={i}
                        className="clickRequestsRow"
                        onClick={row.onClick}
                        style={{
                            cursor: row.onClick ? "pointer" : "default",
                        }}
                    >
                        {columns.map((col) => (
                            <td
                                key={col.key}
                                className="clickRequestsCell"
                                style={col.cellStyle}
                            >
                                {row[col.key]}
                            </td>
                        ))}
                    </tr>
                ))}
                </tbody>
            </table>
        </Scrollbar>
    );
};
